import React from 'react';
import { TitleBar } from './TitleBar';
import { Sidebar } from './Sidebar';
import '../styles/ProtectedShell.css';

/**
 * ProtectedShell - Layout wrapper for authenticated pages
 *
 * Provides a consistent layout structure for all internal pages:
 * - TitleBar with menu and UserAvatar (already integrated)
 * - Sidebar for navigation between pages
 * - Main content area (scrollable)
 *
 * This component is used by RequireAuth to wrap protected content.
 */

interface ProtectedShellProps {
  children: React.ReactNode;
}

export const ProtectedShell: React.FC<ProtectedShellProps> = ({ children }) => {
  return (
    <div className="protected-shell">
      <TitleBar />
      <div className="protected-shell-body">
        <Sidebar />
        <main className="protected-shell-main">
          {children}
        </main>
      </div>
    </div>
  );
};
